module.exports = __webpack_public_path__ + "img/comp.cfa883c9.svg";